import React, { useState } from 'react';
import Popup from "../imagepopup";


function Deloitte() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };

  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p20.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                As a UI/UX Designer under the Enterprise Application Group (EAG) at Deloitte, I was responsible for designing and developing internal enterprise applications catering to various business groups within the organization. Focused on delivering modern, user-friendly, and efficient interfaces, ensuring seamless digital experiences for internal stakeholders.
                </p>
                <p className="mt-15">
                Designed and developed intuitive dashboards, workflow automation tools, and data-driven applications that enhanced productivity and operational efficiency. Leveraged user research, wireframing, prototyping, and front-end development to create accessible and engaging applications tailored to Deloitte’s business needs.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Designer</strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      User Experience Research & Design: Conducted user research, usability testing, and stakeholder interviews to craft intuitive and user-friendly applications.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Wireframing & Prototyping: Designed interactive wireframes and prototypes using tools like iRise and Axure to visualize user flows.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Dashboard & Data Visualization UI: Created interactive dashboards and visual analytics interfaces to help internal teams track KPIs, reports, and insights effectively.
                        </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Workflow Automation & Efficiency: Designed intuitive workflow automation tools that streamlined business processes and improved team productivity.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Design System & Branding Compliance: Maintained Deloitte’s design system and ensured UI consistency across multiple applications and platforms.

                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Accessibility & Performance Optimization: Ensured all applications adhered to WCAG accessibility standards, delivering inclusive and optimized user experiences.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Multi-Disciplinary Teams: Worked closely with developers, business analysts, and leadership teams to translate business requirements into functional and engaging UI solutions.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Multi-Disciplinary Teams: Worked closely with developers, business analysts, and leadership teams to translate business requirements into functional and engaging UI solutions.
                      </h6>
                    </li>
                   
                  </ul>
                  <p className="mt-25">
                  Through this role, I contributed to enhancing internal digital platforms, optimizing user experiences, and improving overall workflow efficiency across various Deloitte business groups, ensuring seamless interaction with critical enterprise applications.
                 </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>Jan 2010</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Designer</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Deloitte</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p21.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p21.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p32.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p32.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p8.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p8.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/freelance">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/aspirezone">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
                  
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Deloitte;
